<template>
  <div>
    
    <!-- Single‑sign‑on button only -->
    <div class="button-container mt-6">
      <memlist-button
        class="mb-8"
        variant="primary"
        data-cy="microsoft-login-button"
        @click="loginWithMicrosoft"
      >
        <img
          src="/assets/images/microsoft.svg"
          style="width:24px;"
          alt="Microsoft logo"
          class="mr-2 h-4"
        />
        Sign in with Microsoft
      </memlist-button>
    </div>

    <!-- Optional: No‑permissions alert if backend redirects you back with a flag -->
    <div
      v-if="showNoPermissions"
      data-cy="no-permissions-alert"
      class="alert alert-danger mt-4"
    >
      <p>{{$t('ACCOUNT.NO_ACCESS_INFO1')}}</p>
      <p>{{$t('ACCOUNT.NO_ACCESS_INFO2')}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SSOLoginComponent',
  data() {
    return {
      showNoPermissions: false,
    };
  },
  mounted() {
    // The backend could bounce you back with ?err=no_access — handle it here if you like
    if (this.$route.query.err === 'no_access') {
      this.showNoPermissions = true;
    }
  },
  methods: {
    loginWithMicrosoft() {
      // Full‑page redirect to the SSO entry point we mounted in the backend
      window.location.href = '/api/v3/entra/login';
    },
  },
};
</script>

<style scoped>
/* re‑use your existing styling so nothing visually changes */
.login-body {
  max-width: 500px;
  padding: 0 1rem;
}

h3.text-center {
  text-align: center;
  margin: 2rem 0;
}

.button-container {
  display: flex;
  justify-content: center;
}
</style>
